var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8761 17.2668C20.3564 15.2614 18.3391 14.0707 16.383 14.6034C15.68 14.7914 15.0687 15.1988 14.6102 15.7315L9.50579 12.692C9.68918 12.1594 9.78087 11.6267 9.78087 11.0313C9.78087 10.3733 9.65861 9.74664 9.41409 9.15129L14.3045 6.26855C14.763 6.80123 15.3743 7.17724 16.0773 7.39658C18.0335 7.92926 20.0508 6.73856 20.5704 4.73318C21.09 2.72779 19.9285 0.659742 17.9724 0.127063C16.0162 -0.405617 13.9989 0.785079 13.4793 2.79046C13.2959 3.51115 13.3264 4.26317 13.5404 4.92118L8.64996 7.83525C7.76357 6.73856 6.4187 6.01788 4.89044 6.01788C2.2007 6.01788 0 8.27393 0 11.0313C0 13.7887 2.2007 16.0448 4.89044 16.0448C6.47983 16.0448 7.88583 15.2614 8.77222 14.0707L13.8461 17.0788C13.6321 17.7368 13.6015 18.4889 13.7849 19.2095C14.3045 21.2149 16.3218 22.4056 18.278 21.8729C20.2342 21.3403 21.3957 19.2722 20.8761 17.2668Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b8fc92283b43ed8527b1726d3676a6fe.svg";
export { ForwardRef as ReactComponent };